function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Insurance_ic",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M60.24 156c0 9.88 7.89 16 17.76 16s18-6.12 18-16V82.59c-6.3 0-12.17 1-17.16 4.14l-.58.33a20.53 20.53 0 00-6.85 6.26C67.27 87 57.82 82.59 46.82 82.59c-9.18 0-17.28 3.08-22.12 7.77A71.54 71.54 0 0183 25.68a17.82 17.82 0 0126.09 0 71.54 71.54 0 0158.21 64.68c-4.84-4.69-12.94-7.77-22.12-7.77-11 0-20.45 4.42-24.59 10.73a20.87 20.87 0 00-7.4-6.58 31.6 31.6 0 00-7.2-2.87 38.71 38.71 0 00-10-1.28",
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 8
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h192v192H0z"
}));

var SvgInsurance = function SvgInsurance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 192 192",
    "aria-hidden": true
  }, props), _ref);
};

export default SvgInsurance;